module.exports = __webpack_public_path__ + "img/sas.d4153a24.gif";